var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { keyframes } from '@emotion/react';
import { Card } from '@workday/canvas-kit-react/card';
import { space, type } from '@workday/canvas-kit-react/tokens';
import { styled, getTranslateFromOrigin, useConstant, createSubcomponent, } from '@workday/canvas-kit-react/common';
import { Flex } from '@workday/canvas-kit-react/layout';
import { getTransformFromPlacement } from './getTransformFromPlacement';
import { usePopupCard, usePopupModel } from './hooks';
var popupAnimation = function (transformOrigin) {
    var translate = getTranslateFromOrigin(transformOrigin, space.xxs);
    return keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    0% {\n      opacity: 0;\n      transform: translate(", "px, ", "px);\n    }\n    100% {\n      opacity: 1;\n      transform: translate(0);\n    }\n  "], ["\n    0% {\n      opacity: 0;\n      transform: translate(", "px, ", "px);\n    }\n    100% {\n      opacity: 1;\n      transform: translate(0);\n    }\n  "])), translate.x, translate.y);
};
var StyledPopupCard = styled(Card)(function (_a) {
    var _b;
    var transformOrigin = _a.transformOrigin, theme = _a.theme;
    if (transformOrigin == null) {
        return {};
    }
    return _b = {
            animation: popupAnimation(transformOrigin),
            animationDuration: '150ms',
            animationTimingFunction: 'ease-out',
            transformOrigin: transformOrigin.vertical + " " + transformOrigin.horizontal
        },
        _b[theme.canvas.breakpoints.down('s')] = {
            animation: popupAnimation({ vertical: 'bottom', horizontal: 'center' }),
            animationDuration: '150ms',
            animationTimingFunction: 'ease-out',
            transformOrigin: 'bottom center',
        },
        // Allow overriding of animation in special cases
        _b['.wd-no-animation &'] = {
            animation: 'none',
        },
        _b;
});
export var PopupCard = createSubcomponent('div')({
    displayName: 'Popup.Card',
    modelHook: usePopupModel,
    elemPropsHook: usePopupCard,
})(function (_a, Element, model) {
    var children = _a.children, elemProps = __rest(_a, ["children"]);
    var transformOrigin = React.useMemo(function () {
        return getTransformFromPlacement(model.state.placement || 'bottom');
    }, [model.state.placement]);
    // As is a Flex that will render an element of `Element`
    var As = useConstant(function () { return Flex.as(Element); });
    return (React.createElement(StyledPopupCard, __assign({ as: As, transformOrigin: transformOrigin, position: "relative", depth: 5, maxWidth: "calc(100vw - " + space.l + ")", flexDirection: "column", minHeight: 0, padding: "m", maxHeight: "calc(100vh - " + (elemProps.margin ? space[elemProps.margin] || elemProps.margin : space.xl) + " * 2)", overflowY: "auto" }, type.levels.subtext.large, elemProps), children));
});
var templateObject_1;
